export const APP_NAVIGATION_COMPONENT_CONFIG = {
  component: null,
};
